import { ChildrenProps } from "@hex-insights/core";
import { PermissionRequired } from "@hex-insights/permissioning";
import { permissions } from "../../../../Utilities";

const admissionsReEnrollmentInquiryPermissions = [
	permissions.StudentEnrollmentIntent.View.Admin,
	permissions.StudentEnrollmentIntent.View.Basic,
];

export type AdmissionsReEnrollmentInquiryViewPermissionRequiredProps = Partial<ChildrenProps>;

export function AdmissionsReEnrollmentInquiryViewPermissionRequired({
	children,
}: AdmissionsReEnrollmentInquiryViewPermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={admissionsReEnrollmentInquiryPermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

const admissionsReEnrollmentPermissions = [permissions.Contract.View.Admin, permissions.Contract.View.Basic];

export type AdmissionsReEnrollmentViewPermissionRequiredProps = Partial<ChildrenProps>;

export function AdmissionsReEnrollmentViewPermissionRequired({
	children,
}: AdmissionsReEnrollmentViewPermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={admissionsReEnrollmentPermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

const admissionsPermissions = [...admissionsReEnrollmentInquiryPermissions, ...admissionsReEnrollmentPermissions];

export type AdmissionsViewPermissionRequiredProps = Partial<ChildrenProps>;

export function AdmissionsViewPermissionRequired({ children }: AdmissionsViewPermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={admissionsPermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}
